import React, { useEffect, useState } from "react";
import { colors } from "../../../theme/colors";
import { MdReplay } from "react-icons/md";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { Button, Link } from "../../Components/Button";
import { Body, Subheader } from "../../Components/Text";
import { RiCheckboxCircleFill } from "react-icons/ri";
import { FaPlay } from "react-icons/fa";
import { IoIosNotifications } from "react-icons/io";
import { MdLaunch } from "react-icons/md";
import theme from "../../../theme/themeThree";
import {
  OverlayEditTitle,
  OverlayRemix,
  OverlayShare,
  OverlayDownload,
  OverlayMobile,
  OverlayInfo,
  OverlaySettings,
} from "../../Components/Button/PlayerOverlay";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { PartnerViewSession, IsUserLoggedIn } from "../../State";
import {
  NotificationBannerCopyType,
  OverlayTriggerState,
} from "MVVM/State/iframe";
import { useWindowSize } from "../../Hooks/useWindowSize";
import { SharePopout } from "../SharePopout";
import { AiOutlineStar } from "react-icons/ai";
import { AttemptedAction } from "../AttemptedAction";
import { isFaceItPartner } from "../../Utilities/Player";
import { analytics } from "MVVM/Analytics";
import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";

export function PartnerOverlay({
  onReplayClick,
  display,
  translateHook,
  platform,
  overlayTrigger,
  player,
  renderMatchHistoryWidget,
}: any) {
  const [partnerViewSession] = useRecoilState(PartnerViewSession);
  const isLoggedIn = useRecoilValue(IsUserLoggedIn);
  const setOverlayTrigger = useSetRecoilState(OverlayTriggerState);
  const { overlayConfig, dynamicCta } = partnerViewSession;
  const size = useWindowSize();
  const [ctaSize, setCtaSize] = useState("default");
  const [shouldShowOverlay, setShouldShowOverlay] = useState(
    display && overlayConfig.display,
  );
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [displaySharePopout, setDisplaySharePopout] = useState(false);
  const [attemptedAction, setAttemptedAction] = useState("");
  const shouldShowCta = dynamicCta?.mainCopy;
  const isFaceItPartnerFlag = isFaceItPartner(platform);
  const analyticsContext = useAnalyticsContext(platform);
  const notificationBannerCopyType = useRecoilValue(NotificationBannerCopyType);

  useEffect(() => {
    if (shouldShowOverlay) {
      analytics.track("Overlay - Display", {
        isLoggedIn: isLoggedIn,
        knownUser: overlayConfig?.knownUser,
        shareId: overlayConfig?.shareId,
        link: partnerViewSession?.dynamicCta?.link,
        type: partnerViewSession?.dynamicCta?.type,
        isClaimable: partnerViewSession.dynamicCta.isClaimable,
        ...analyticsContext,
      });
      if (
        partnerViewSession?.promotion?.display &&
        partnerViewSession?.promotion?.name &&
        partnerViewSession?.overlayConfig?.knownUser &&
        notificationBannerCopyType === "promotion"
      ) {
        analytics.track("Promotion - Impression", {
          promotionName: partnerViewSession?.promotion?.name,
          type: "videoPlayer",
          ...analyticsContext,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowOverlay, partnerViewSession?.promotion?.display]);

  useEffect(() => {
    setShouldShowOverlay(display && overlayConfig.display);
  }, [overlayConfig, display]);

  useEffect(() => {
    if (size.width && size.width <= 700 && ctaSize !== "tiny") {
      setCtaSize("tiny");
    }
    if (size.width && size.width > 700 && ctaSize !== "default") {
      setCtaSize("default");
    }
  }, [size, ctaSize]);

  const closeOthers = () => {
    setSettingsOpen(false);
    setDisplaySharePopout(false);
  };

  const getSettings = () => {
    switch (overlayConfig.resconfig) {
      case "1":
        return (
          <>
            <SettingsRow isActive={true}>
              <StyledCheckIcon />
              <StyledSettingsText pl={2}>
                720P30 (Current Resolution)
              </StyledSettingsText>
            </SettingsRow>
            <SettingsRow
              onClick={() => {
                try {
                  analytics.track("Overlay - Quality Click", {
                    knownUser: overlayConfig?.knownUser,
                    shareId: overlayConfig?.shareId,
                    type: "Desktop 1080P60 (16:9)",
                    ...analyticsContext,
                  });
                } catch (e) {}
                if (overlayConfig.knownUser)
                  window.open(overlayConfig.quality.remixLink, "_blank");
                else setAttemptedAction("adjustQuality");
              }}
            >
              <StyledStar />
              <StyledSettingsText pl={2}>
                Desktop 1080P60 (16:9)
              </StyledSettingsText>
            </SettingsRow>
            <SettingsRow
              onClick={() => {
                try {
                  analytics.track("Overlay - Quality Click", {
                    knownUser: overlayConfig?.knownUser,
                    shareId: overlayConfig?.shareId,
                    type: "Mobile 1080P60 (9:16)",
                    ...analyticsContext,
                  });
                } catch (e) {}
                if (overlayConfig.knownUser)
                  window.open(overlayConfig.quality.mobileLink, "_blank");
                else setAttemptedAction("adjustQuality");
              }}
            >
              <StyledStar />
              <StyledSettingsText pl={2}>
                Mobile 1080P60 (9:16)
              </StyledSettingsText>
            </SettingsRow>
          </>
        );
      case "2":
        return (
          <>
            <SettingsRow isActive={true}>
              <StyledCheckIcon />
              <StyledSettingsText pl={2}>
                Desktop 1080P60 (16:9)
              </StyledSettingsText>
            </SettingsRow>
            <SettingsRow
              onClick={() => {
                try {
                  analytics.track("Overlay - Quality Click", {
                    knownUser: overlayConfig?.knownUser,
                    shareId: overlayConfig?.shareId,
                    type: "Mobile 1080P60 (9:16)",
                    ...analyticsContext,
                  });
                } catch (e) {}
                if (overlayConfig.knownUser)
                  window.open(overlayConfig.mobile.link, "_blank");
                else setAttemptedAction("adjustQuality");
              }}
            >
              <StyledStar />
              <StyledSettingsText pl={2}>
                Mobile 1080P60 (9:16)
              </StyledSettingsText>
            </SettingsRow>
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <AttemptedAction
        translateHook={translateHook}
        overlayConfig={overlayConfig}
        type={attemptedAction}
        setAttemptedAction={setAttemptedAction}
        platform={platform}
      />
      <Box
        className="hover-controls"
        style={{
          display: shouldShowOverlay ? "none" : "block",
          width: "100%",
          pointerEvents: "none",
        }}
      >
        <Flex style={{ justifyContent: "space-between", marginTop: "30px" }}>
          <LeftSideButtonContainer>
            <InfoPosition>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledInfo
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  onClick={() => {
                    closeOthers();
                    setAttemptedAction("info");
                    setOverlayTrigger("hover");
                    try {
                      analytics.track("Overlay - Info Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledInfo>
              </DefaultBorder>
            </InfoPosition>
            <SettingsButtonPosition>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledSettings
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  onClick={() => {
                    try {
                      if (!overlayConfig.knownUser) {
                        closeOthers();
                        setAttemptedAction("adjustQuality");
                      } else {
                        setAttemptedAction("thirdPartySettings");
                      }
                      setOverlayTrigger("hover");
                      analytics.track("Overlay - Settings Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledSettings>
              </DefaultBorder>
            </SettingsButtonPosition>
            {settingsOpen && (
              <SettingsContainerPosition>
                {overlayConfig.resconfig && <> {getSettings()}</>}
              </SettingsContainerPosition>
            )}
          </LeftSideButtonContainer>
          <StyledOptions>
            <StyledButtonWrapper>
              {!renderMatchHistoryWidget && (
                <Box style={{ height: "52px" }}>
                  <DefaultBorder
                    sx={{ ...theme.borders["overlayDefault"] }}
                    style={{
                      position: "relative",
                      height: "46px",
                      marginTop: "3px",
                      marginBottom: "6px",
                    }}
                  >
                    <NotificationContainer
                      onClick={() => player.pause()}
                      style={{ height: "40px" }}
                    >
                      <StyledNotificationBell />
                      <NotificationDot style={{ top: "9px" }} />
                    </NotificationContainer>
                  </DefaultBorder>
                </Box>
              )}
              <Box style={{ position: "relative" }}>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledShare
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    href={overlayConfig.share.link}
                    onClick={() => {
                      setDisplaySharePopout(!displaySharePopout);
                      try {
                        analytics.track("Overlay - Share Click", {
                          isLoggedIn: isLoggedIn,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  />
                </DefaultBorder>
                <SharePopout
                  overlayConfig={overlayConfig}
                  display={displaySharePopout}
                  setDisplaySharePopout={setDisplaySharePopout}
                  setAttemptedAction={setAttemptedAction}
                />
              </Box>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledDownload
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  href={overlayConfig.edit.link}
                  onClick={() => {
                    closeOthers();

                    try {
                      analytics.track("Overlay - Download Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        directDownload: isFaceItPartnerFlag,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }

                    if (isFaceItPartnerFlag) {
                      return window.open(
                        `${process.env.REACT_APP_S3_CLIP_BUCKET}/${partnerViewSession?.clip?.clipLink}`,
                      );
                    }

                    if (!overlayConfig.knownUser) {
                      setAttemptedAction("download");
                    } else {
                      window.open(overlayConfig.download.link, "_blank");
                    }
                  }}
                ></StyledDownload>
              </DefaultBorder>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledMobile
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  href={overlayConfig.edit.link}
                  onClick={() => {
                    closeOthers();
                    if (!overlayConfig.knownUser) {
                      setAttemptedAction("mobile");
                    } else {
                      window.open(overlayConfig.mobile.link, "_blank");
                    }

                    try {
                      analytics.track("Overlay - Mobile Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledMobile>
              </DefaultBorder>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledRemix
                  classification={"overlayDefault"}
                  size={"overlayRemixOption"}
                  onClick={() => {
                    try {
                      closeOthers();
                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("addfx");
                      } else {
                        window.open(overlayConfig.remix.link, "_blank");
                      }
                      analytics.track("Overlay - Remix Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledRemix>
              </DefaultBorder>{" "}
              {!isFaceItPartnerFlag && (
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledEditTitle
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    onClick={() => {
                      closeOthers();

                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("editTitle");
                      } else {
                        window.open(overlayConfig.edit.link, "_blank");
                      }
                      try {
                        analytics.track("Overlay - Edit Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  ></StyledEditTitle>
                </DefaultBorder>
              )}
            </StyledButtonWrapper>
          </StyledOptions>
        </Flex>
      </Box>
      <ClipOverlay
        className="videoOverlay"
        display={shouldShowOverlay ? "block" : "none"}
        $overlayTrigger={overlayTrigger}
        $renderMatchHistoryWidget={renderMatchHistoryWidget}
      >
        <Flex style={{ justifyContent: "space-between", marginTop: "30px" }}>
          <LeftSideButtonContainer>
            <InfoPosition>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledInfo
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  onClick={() => {
                    closeOthers();
                    setAttemptedAction("info");
                    try {
                      analytics.track("Overlay - Info Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledInfo>
              </DefaultBorder>
            </InfoPosition>
            {!isFaceItPartnerFlag && (
              <SettingsButtonPosition>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledSettings
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    onClick={() => {
                      try {
                        if (!overlayConfig.knownUser) {
                          closeOthers();
                          setAttemptedAction("adjustQuality");
                        } else {
                          setAttemptedAction("thirdPartySettings");
                        }
                        analytics.track("Overlay - Settings Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  ></StyledSettings>
                </DefaultBorder>
              </SettingsButtonPosition>
            )}
            {settingsOpen && (
              <SettingsContainerPosition>
                {overlayConfig.resconfig && <> {getSettings()}</>}
              </SettingsContainerPosition>
            )}
          </LeftSideButtonContainer>
          <StyledOptions>
            {!renderMatchHistoryWidget && overlayTrigger !== "preplay" && (
              <NotificationBanner
                link={partnerViewSession?.notificationBanner?.link}
                thumbnail={partnerViewSession?.notificationBanner?.thumbnail}
                text={partnerViewSession?.notificationBanner?.text}
                buttonText={partnerViewSession?.notificationBanner?.buttonText}
                platform={platform}
                copy={partnerViewSession?.notificationBanner?.copy}
                type={
                  partnerViewSession.promotion.display
                    ? "promotion"
                    : partnerViewSession.claimableCount > 0
                    ? "claimClips"
                    : "default"
                }
              />
            )}
            <StyledButtonWrapper>
              <Box style={{ position: "relative" }}>
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledShare
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    href={overlayConfig.share.link}
                    onClick={() => {
                      setDisplaySharePopout(!displaySharePopout);
                      try {
                        analytics.track("Overlay - Share Click", {
                          isLoggedIn: isLoggedIn,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  />
                </DefaultBorder>
                <SharePopout
                  overlayConfig={overlayConfig}
                  display={displaySharePopout}
                  setDisplaySharePopout={setDisplaySharePopout}
                  setAttemptedAction={setAttemptedAction}
                />
              </Box>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledDownload
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  href={overlayConfig.edit.link}
                  onClick={() => {
                    closeOthers();

                    try {
                      analytics.track("Overlay - Download Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        directDownload: isFaceItPartnerFlag,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }

                    if (isFaceItPartnerFlag) {
                      return window.open(
                        `${process.env.REACT_APP_S3_CLIP_BUCKET}/${partnerViewSession?.clip?.clipLink}`,
                      );
                    }

                    if (!overlayConfig.knownUser) {
                      setAttemptedAction("download");
                    } else {
                      window.open(overlayConfig.download.link, "_blank");
                    }
                  }}
                ></StyledDownload>
              </DefaultBorder>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledMobile
                  classification={"overlayDefault"}
                  size={"overlayOption"}
                  href={overlayConfig.edit.link}
                  onClick={() => {
                    closeOthers();
                    if (!overlayConfig.knownUser) {
                      setAttemptedAction("mobile");
                    } else {
                      window.open(overlayConfig.mobile.link, "_blank");
                    }

                    try {
                      analytics.track("Overlay - Mobile Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledMobile>
              </DefaultBorder>
              <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                <StyledRemix
                  classification={"overlayDefault"}
                  size={"overlayRemixOption"}
                  onClick={() => {
                    try {
                      closeOthers();
                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("addfx");
                      } else {
                        window.open(overlayConfig.remix.link, "_blank");
                      }
                      analytics.track("Overlay - Remix Click", {
                        isLoggedIn: isLoggedIn,
                        knownUser: overlayConfig.knownUser,
                        shareId: overlayConfig.shareId,
                        ...analyticsContext,
                      });
                    } catch (e) {
                      console.log(e);
                    }
                  }}
                ></StyledRemix>
              </DefaultBorder>{" "}
              {!isFaceItPartnerFlag && (
                <DefaultBorder sx={{ ...theme.borders["overlayDefault"] }}>
                  <StyledEditTitle
                    classification={"overlayDefault"}
                    size={"overlayOption"}
                    onClick={() => {
                      closeOthers();

                      if (!overlayConfig.knownUser) {
                        setAttemptedAction("editTitle");
                      } else {
                        window.open(overlayConfig.edit.link, "_blank");
                      }
                      try {
                        analytics.track("Overlay - Edit Click", {
                          isLoggedIn: isLoggedIn,
                          knownUser: overlayConfig.knownUser,
                          shareId: overlayConfig.shareId,
                          ...analyticsContext,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                  ></StyledEditTitle>
                </DefaultBorder>
              )}
            </StyledButtonWrapper>
          </StyledOptions>
        </Flex>
        {!renderMatchHistoryWidget && overlayTrigger !== "preplay" && (
          <StyledReplayWrapper>
            <StyledButton flex={true} classification={"bigReplay"}>
              <MdReplay
                size={40}
                onClick={() => {
                  try {
                    analytics.track("Overlay - Replay Click", {
                      isLoggedIn: isLoggedIn,
                      knownUser: overlayConfig.knownUser,
                      shareId: overlayConfig.shareId,
                      ...analyticsContext,
                    });
                  } catch (e) {
                    console.log(e);
                  }
                  onReplayClick();
                }}
              />
            </StyledButton>
          </StyledReplayWrapper>
        )}
      </ClipOverlay>
    </>
  );
}

const Notification = styled.span`
  position: absolute;
  top: 0px;
  right: -5px;
  padding: 6px;
  border-radius: 50%;
  background: red;
  color: white;
`;

const IndependentTextWrapper = styled(Flex)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: 50px;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  @media (max-width: 700px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 300px) {
    display: none;
  }
  @media (max-height: 330px) {
    display: none;
  }
`;

const StyledStar = styled<any>(AiOutlineStar)`
  transition: color 0.1s;
`;

const ClipOverlay = styled(Flex)<{
  $overlayTrigger: string;
  $renderMatchHistoryWidget: boolean;
}>`
  position: absolute;
  pointer-events: none;
  background: ${(props) =>
    props.$overlayTrigger === "preplay" || props.$renderMatchHistoryWidget
      ? "transparent"
      : colors.midnightAlpha80};
  top: 0;
  left: 0;
  display: ${(props) => {
    return props.display;
  }};

  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition:
    opacity 0.2s,
    visibility 0s 0.2s;
`;

const StyledCheckIcon = styled(RiCheckboxCircleFill)`
  color: ${(props) => props.theme.colors.envy};
  width: 16px;
  height: 16px;
`;

const CtaButton = styled(Button)`
  pointer-events: auto;
  border-radius: 999px;
  position: absolute;
  top: -45%;
  @media (max-width: 700px) {
    top: -18%;
  }
  @media (max-height: 330px) {
    top: -8%;
  }
`;

const StyledHeadline = styled(Subheader)`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.white};
  text-align: center;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  @media (max-width: 700px) {
    font-size: 16px;
  }
  @media (max-width: 300px) {
    font-size: 14px;
  }
`;

const StyledCta = styled(Flex)<{ shouldShowCta: boolean }>`
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  display: ${(props) => (props.shouldShowCta ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 3;
  @media (max-width: 700px) {
    bottom: 10px;
  }
  @media (max-height: 330px) {
    bottom: 10px;
  }
`;

const StyledReplayWrapper = styled(Flex)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
`;

const StyledButton = styled(Button)`
  pointer-events: auto;
  border-radius: 999px;
  background: ${(props) => props.theme.colors.midnightAlpha80};
  &:hover {
    background: ${(props) => props.theme.colors.midnightAlpha90};
  }
`;

const StyledOptions = styled(Flex)`
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
`;

const StyledButtonWrapper = styled(Flex)`
  flex-direction: column;
  gap: 10px;
`;

const DefaultBorder = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.midnightAlpha60};
  border-radius: 8px;
  padding: 3px;
  background: ${(props) => props.theme.colors.midnightAlpha80};
`;

const LeftSideButtonContainer = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

const InfoPosition = styled(Box)`
  position: relative;
`;

const SettingsButtonPosition = styled(Box)`
  position: relative;
`;

const SettingsContainerPosition = styled(Box)`
  position: absolute;
  top: 55px;
  left: 0;
  background: ${(props) => props.theme.colors.midnightAlpha90};
  border-radius: 8px;
  padding: 10px;
  z-index: 10;
`;

const SettingsRow = styled(Flex)<{ isActive?: boolean }>`
  align-items: center;
  padding: 8px 12px;
  cursor: ${(props) => (props.isActive ? "default" : "pointer")};
  border-radius: 4px;
  &:hover {
    background: ${(props) =>
      props.isActive ? "transparent" : props.theme.colors.midnightAlpha70};
  }
`;

const StyledSettingsText = styled(Body)`
  color: ${(props) => props.theme.colors.white};
  font-size: 12px;
`;

const StyledInfo = styled(OverlayInfo)`
  pointer-events: auto;
`;

const StyledSettings = styled(OverlaySettings)`
  pointer-events: auto;
`;

const StyledShare = styled(OverlayShare)`
  pointer-events: auto;
`;

const StyledDownload = styled(OverlayDownload)`
  pointer-events: auto;
`;

const StyledMobile = styled(OverlayMobile)`
  pointer-events: auto;
`;

const StyledRemix = styled(OverlayRemix)`
  pointer-events: auto;
`;

const StyledEditTitle = styled(OverlayEditTitle)`
  pointer-events: auto;
`;

const NotificationContainer = styled(Flex)`
  position: relative;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 8px;
  background: ${(props) => props.theme.colors.midnightAlpha80};
  &:hover {
    background: ${(props) => props.theme.colors.midnightAlpha90};
  }
`;

const StyledNotificationBell = styled(IoIosNotifications)`
  color: ${(props) => props.theme.colors.white};
  font-size: 20px;
`;

const NotificationDot = styled(Box)`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.error};
`;

// NotificationBanner component - this should be imported from the EmbeddablePlayer
const NotificationBanner = ({
  link,
  thumbnail,
  text,
  buttonText,
  platform,
  copy,
  type,
}: any) => {
  return <Box>{/* Placeholder for NotificationBanner component */}</Box>;
};
